import { c, h } from '@debbie/cortex/dist/index.js'
import { useMe } from '@debbie/cortex/dist/me/index.js'
import { RootState } from '@debbie/cortex/dist/reducer.js'
import THEME from '@debbie/iris/dist/theme.js'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { styled } from 'styled-components'

type Props = {}

const TopNav = (props: Props) => {
  const lang = useSelector((s: RootState) => s.lang)

  return (
    <>
      <Wrapper>
        <div>{lang.tribunal.meetings}</div>
        <Logout
          onClick={() => {
            c.auth.logout()
          }}
        >
          {lang.auth.logout}
        </Logout>
      </Wrapper>
      <Stub />
    </>
  )
}

const Wrapper = styled.div`
  width: 100%;
  height: 50px;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 1em;
  background: #fff;
  z-index: 16;
  box-shadow: 0px 1px 20px 0px rgba(0, 0, 0, 0.1);
`

const Stub = styled.div`
  height: 50px;
`

const Logout = styled.div`
  cursor: pointer;
`

export default TopNav
